import React, { type JSX } from "react";

import {
    RichTextBlock as RichTextBlockValue,
    RichTextField as RichTextFieldValue,
} from "@reactivated";

export interface RichTextProps<T> {
    /**
     * Field/Block value
     */
    value: T;

    /**
     * Optional. If set to true, wraps the rich text in a span element instead
     * of the default <div> element.
     */
    inline?: boolean;

    /**
     * Optional. Set a class name on the top level wrapper element.
     */
    className?: string | null;

    /**
     * Optional. Custom tag name to use for the top level wrapper element.
     * Overrides the `inline` prop setting.
     */
    tagName?: keyof JSX.IntrinsicElements | null;
}

type RichTextFieldProps = RichTextProps<RichTextFieldValue>;
type RichTextBlockProps = RichTextProps<RichTextBlockValue>;

export const RichText = (props: RichTextFieldProps) => {
    const richTextProps = {
        className: props.className,
        dangerouslySetInnerHTML: {
            __html: props.value.html,
        },
    };
    let tagName: keyof JSX.IntrinsicElements = "div";
    if (props.inline) {
        tagName = "span";
    }
    if (props.tagName) {
        tagName = props.tagName;
    }
    return React.createElement(tagName, richTextProps);
};

export const RichTextBlock = (props: RichTextBlockProps) => {
    return (
        <RichText
            {...props}
            value={{
                _type: "RichTextField",
                html: props.value,
            }}
        />
    );
};
